import { ViewModel,View, ObservableArray } from "binder"
import  { InWayView } from "./inWay-view"
import { IImportingPart } from "../../ipart";
import { ServerConnection } from "src/server/serverConnection";
import moment from "moment";
import { Converters } from "src/uicomponents/converters";
import { exportToCsv } from "src/uicomponents/components/utilities";
import { ExcelExporter } from "src/common/utilities";
import { FileSelectorViewModel } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ImportProductViewModel } from "../../importProduct-viewModel";

export class InWayViewModel extends ViewModel implements IImportingPart{
    constructor(parentViewModel: ImportProductViewModel) {
        super(parentViewModel);

        this.items = ObservableArray.create<item>();
        this.title = 'InWay';
        this._typedParent = parentViewModel;
        this.fileSelector = new FileSelectorViewModel(this);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new InWayView();
    }
    public getTypeId(): string {
        return "VM-845E906B-7148-42FA-9852-B6BFA6D73DD4"
    }

    private _typedParent : ImportProductViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<item>) { this._items = v; } public get items(): ObservableArray<item> { return this._items;} private _items: ObservableArray<item>;
    
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set fileSelector(v: FileSelectorViewModel) { this._fileSelector = v; } public get fileSelector(): FileSelectorViewModel { return this._fileSelector;} private _fileSelector: FileSelectorViewModel;
    
    needsProcessToLoad(): boolean {
        return false;
    }
    async load(processId: any): Promise<any> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/GetAllInWay',{
            });

            this.items.update(...result.InWayProducts.map((q,i)=>{
                let r = new item(this);
                r.index = i+1;
                r.id = q.Id;
                r.productId = q.ProductId;
                r.productName = q.ProductName;
                r.code = q.ProductCode;
                r.pnc = q.Pnc;
                r.brand = q.Brand;
                r.remainingAmount = q.RemainingAmount;
                r.newRemainingAmount = q.RemainingAmount;
                r.initialAmount = q.InitialAmount;
                r.creationTime =moment.utc(q.CreationTime);
                r.providerName = q.ProviderName;
                r.price = q.Price;
                r.partNumberTotalInWay = q.PartNumberTotalInway;
                r.productTotalInWay  = q.ProductTotalInWay;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    exportExcel(){
        let converter = new Converters();
        let data = this.items.map((x,i)=>{
            let result = {
                'ردیف':i+1,
                'ID':x.id,
                'تامین کننده':x.providerName,
                'تاریخ ایجاد':converter.persianDateConverter(x.creationTime),
                'نام کالا':x.productName,
                'PNC':x.pnc,
                'کد':x.code,
                'برند':x.brand,
                'قیمت':x.price,
                'در راه':x.remainingAmount,
                'درراه جدید':x.newRemainingAmount,
                'تعداد اولیه':x.initialAmount,
                'درراه partnumber':x.partNumberTotalInWay,
                'درراه کالا':x.productTotalInWay
            };
            return result;
        });
        new ExcelExporter().export('در راه.xlsx',data);
    }

    async importExcel(){
        try {
            let errors :string[]= [];
            if(!this.fileSelector?.isFileChoosed()){
                errors.push('فایلی انتخاب نشده است.');
            }
            let validationResult = errors.join("\n");
            if(validationResult != ""){
                await this.messageBoxConfirmWarning(validationResult,"خطا");
                return ;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/ReadInWayProductsFromExcel',{
                ExcelFile : this.fileSelector.filecontent
            });
            if (result.IsSuccessful)
                {
                    await this.messageBoxConfirmSuccess('در راه جدیدها با موفقیت بروزسانی شد.','عملیات موفق');
                    this.load(null);
                }
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set productId(v: string) { this._productId = v; } public get productId(): string { return this._productId;} private _productId: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set pnc(v: string) { this._pnc = v; } public get pnc(): string { return this._pnc;} private _pnc: string;
    public set brand(v: string) { this._brand = v; } public get brand(): string { return this._brand;} private _brand: string;
    public set remainingAmount(v: number) { this._remainingAmount = v; } public get remainingAmount(): number { return this._remainingAmount;} private _remainingAmount: number;
    public set newRemainingAmount(v: number) { this._newRemainingAmount = v; } public get newRemainingAmount(): number { return this._newRemainingAmount;} private _newRemainingAmount: number;
    public set initialAmount(v: number) { this._initialAmount = v; } public get initialAmount(): number { return this._initialAmount;} private _initialAmount: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set providerName(v: string) { this._providerName = v; } public get providerName(): string { return this._providerName;} private _providerName: string;
    public set price(v: number) { this._price = v; } public get price(): number { return this._price;} private _price: number;
    public set partNumberTotalInWay(v: number) { this._partNumberTotalInWay = v; } public get partNumberTotalInWay(): number { return this._partNumberTotalInWay;} private _partNumberTotalInWay: number;
    public set productTotalInWay(v: number) { this._productTotalInWay = v; } public get productTotalInWay(): number { return this._productTotalInWay;} private _productTotalInWay: number;
    
    async update(){
        try {
            
            let result = await ServerConnection.callServer('/Complex/ImportProductServices/UpdateInwayAmount',{
                Id:this.id,
                NewAmount : this.newRemainingAmount
            });
            if(result.IsSuccessful){
                alert('عملیات با موفقیت انجام شد');
            }else{
                alert('خطا در انجام عملیات');
            }
        } catch (ex) {
            console.log(ex);
            alert('خطا در انجام عملیات');
        } finally {
        }
    }
}

